module.exports = __webpack_public_path__ + "img/img-b78969.png";